import { Component } from "@angular/core";
import { IFilterAngularComp } from "ag-grid-angular";
import { IDoesFilterPassParams, AgPromise, IFilterParams, IAfterGuiAttachedParams } from "ag-grid-community";
import { SyncStatusFilterOption } from "./sync-status-filter-options";

@Component({
  selector: 'sync-status-filter',
  templateUrl: './sync-status-filter.component.html',
  styleUrls: ['./sync-status-filter.component.scss'],
})
export class SyncStatusFilterComponent implements IFilterAngularComp {

  public selectableOptions: SyncStatusFilterOption[];
  public allOptionsSelected: boolean = false;
  public showAllOption: boolean = false;

  private filterParams: IFilterParams;
  private columnField: string;
  private comparator;
  private filterValueGetter;

  constructor() {
  }

  isFilterActive(): boolean {
    const selectedCount = this.getSelectedCount();
    return selectedCount !== 0 && selectedCount !== this.selectableOptions.length;
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    if(this.comparator) {
      return this.comparator(params);
    }

    let columnData;
    if(this.filterValueGetter) {
      columnData = this.filterValueGetter(params.data);
    } else {
      columnData = params.data[this.columnField];
    }

    return !!this.selectableOptions
              .filter(p => p.selected)
              .find( p =>  p.value === columnData);
  }

  getModel() {
    const selectedCount = this.getSelectedCount();
    if(selectedCount === 0 || selectedCount === this.selectableOptions.length) {
      return null;
    }
    return this.selectableOptions.filter(p => p.selected);
  }

  setModel(model: any): void | AgPromise<void> {
    if(model) {
      this.selectableOptions.forEach(option => {
        const filter = model.find(m => m.id == option.id);
        option.selected = filter ? filter.selected : false;
      });
    }
    if(!model) {
      this.selectableOptions.forEach(p => p.selected = true);
      this.allOptionsSelected = true;
    }
  }

  agInit(params: any): void {
    this.filterParams = params;

    this.filterValueGetter = params.filterValueGetter;
    this.comparator = params.comparator;
    this.selectableOptions = params.selectableOptions;
    this.columnField = params.colDef.field;
    this.showAllOption = params.showAllOption
    this.toggleAll();
  }

  toggleAll(): void {
    this.allOptionsSelected = !this.allOptionsSelected;
    this.selectableOptions.forEach(p => p.selected = this.allOptionsSelected);
    this.filterParams.filterChangedCallback();
  }

  toggleOption(operation: SyncStatusFilterOption): void {
    operation.selected = !operation.selected;
    const selectedCount = this.getSelectedCount();
    this.allOptionsSelected = selectedCount === this.selectableOptions.length ? true : false;
    this.filterParams.filterChangedCallback();
  }


  afterGuiAttached?(params?: IAfterGuiAttachedParams) {
    if(this.getSelectedCount() === 0) {
      this.allOptionsSelected = true;
      this.selectableOptions.forEach(p => p.selected = this.allOptionsSelected);
    }
  }

   private getSelectedCount(): number {
    return this.selectableOptions.filter(option => option.selected).length;
  }
}
